import React from "react";
import { Label } from "components/form";
import * as Styled from "./styled";
import { MAX_SCORE, MIN_PASSWORD_LENGTH } from "../constants";

interface Props {
  score: number;
  message: string[];
  label: string;
  password: string;
}

const PasswordStrength: React.FC<Props> = ({
  score,
  message,
  label,
  password,
}) => {
  // The percentage calculated here is for visual purposes. It allows for some movement as the user types.
  // The percentage will be 100 when the score is 3 and then password is 12 characters long, both of which are requirements.
  // This number can exceed 100, allowing for additional visual effects.
  const strengthPercentage =
    ((score +
      Math.min(password.length, MIN_PASSWORD_LENGTH) / MIN_PASSWORD_LENGTH) /
      MAX_SCORE) *
    100;

  return (
    <Styled.Wrapper>
      <Styled.LabelWrapper>
        <Label>Strength</Label>

        {score > 0 && (
          <Styled.StrengthTag $score={score}>{label}</Styled.StrengthTag>
        )}
      </Styled.LabelWrapper>

      <Styled.Meter $strengthPercentage={strengthPercentage} />

      <Styled.Message>{message.length > 0 && message.join(" ")}</Styled.Message>
    </Styled.Wrapper>
  );
};

export default PasswordStrength;
